import React from 'react';
import { DndProvider } from 'react-dnd';
import { Router } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import { createBrowserHistory } from 'history';
import { QueryClientProvider } from '@tanstack/react-query';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { AuthProvider } from '@sopranodesign/pulse-auth';
import { LanguageProvider } from '@sopranodesign/pulse-hooks';
import { DeviceProvider } from '@sopranodesign/pulse-component-hooks';
import { SubscriptionProvider } from '@sopranodesign/pulse-subscribe';
import { NotificationProvider, ModalProvider } from '@sopranodesign/pulse-components';

import './config/dayjs';
import queryClient from './config/queryClient';
import Cms from './Cms';
import { ReportingProvider, PulseProvider } from './Providers/index';

import './styles/global.css';

const history = createBrowserHistory({
  basename: process.env.REACT_APP_ROUTE_PREFIX
});

const render = (options = {}) => {
  const root = createRoot(document.getElementById("root"));
  root.render(
    <ReportingProvider>
      <DeviceProvider>
        <QueryClientProvider client={queryClient}>
          <PulseProvider options={options}>
            <Router history={history}>
              <NotificationProvider>
                <ModalProvider>
                  <SubscriptionProvider url={process.env.REACT_APP_SOCKET_SERVER}>
                    <AuthProvider>
                      <LanguageProvider>
                        <DndProvider backend={HTML5Backend}>
                          <Cms />
                        </DndProvider>
                      </LanguageProvider>
                    </AuthProvider>
                  </SubscriptionProvider>
                </ModalProvider>
              </NotificationProvider>
            </Router>
          </PulseProvider>
        </QueryClientProvider>
      </DeviceProvider>
    </ReportingProvider>
  );
};

const pulse = {
  render
};

export default pulse;
